import { useDirection, useSearch, useTranslation } from '@eti/providers';
import { css, etiColors } from '@eti/styles';
import { breakpoints, Inline, Heading, Text } from '@etg/wings';
import { TripType } from '@eti/schema-types';
import { screenReadersOnlyStyles } from '../../../../utils/styleUtils';
import type { BoundType } from '../../../order-details/models';
import TripDetailsLink from '../TripDetailsLink';
import { getTripTypeIcon } from './utils';

const headingStyles = css`
  color: ${etiColors.black};
`;

interface TripDetailsTitleProps {
  bounds: BoundType[];
}

const TripDetailsTitle = ({ bounds }: TripDetailsTitleProps) => {
  const { t } = useTranslation();
  const { currentSearchData } = useSearch();
  const { direction } = useDirection();

  const { destination, origin, routes, tripType } = currentSearchData!;
  const TripTypeIcon = getTripTypeIcon(direction, tripType);
  const tripTypeTitleForSrOnly =
    tripType === TripType.Return
      ? t('ScreenReader.ReturnTrip.AriaLabel.Text')
      : t('ScreenReader.OneWayTrip.AriaLabel.Text');
  let destinationCode = routes?.[routes.length - 1].destinationCode;
  if (tripType === TripType.Return || tripType === TripType.OneWay) {
    destinationCode = routes?.[0].destinationCode;
  }
  const isMobileDevice = window.matchMedia(`(max-width: ${breakpoints._768})`).matches;

  return (
    <Inline alignY="center" data-testid="tripDetails-title-TitleText" spacing={16}>
      <Heading className={headingStyles} level={1}>
        <Inline alignY="center" role="paragraph" spacing={8}>
          <Text className={screenReadersOnlyStyles} readOnly>
            {tripTypeTitleForSrOnly}
          </Text>
          {isMobileDevice ? routes?.[0].originCode : `${origin?.city} (${routes?.[0].originCode})`}
          <TripTypeIcon
            aria-hidden={tripType !== TripType.OneWay}
            aria-label={t('Air.Search.CitiesSelection.Placeholder.To')}
            size={isMobileDevice ? 16 : 22}
            weight="fill"
          />
          {isMobileDevice ? destinationCode : `${destination?.city} (${destinationCode})`}
        </Inline>
      </Heading>
      <TripDetailsLink bounds={bounds} tripType={tripType!} />
    </Inline>
  );
};

export default TripDetailsTitle;
